export default __webpack_public_path__ + "static/media/join-left.63f76406.svg";